import { useCallback, useRef } from 'react';

export const useReachedTheEndListener = (threshold: number = 100) => {
  const ref = useRef<HTMLDivElement>(null);

  const onScroll = useCallback(
    (callback: Function) => () => {
      const divElement = ref.current;
      if (!divElement) return;
      const scrollCurrentIndex = Math.round(divElement.offsetHeight + divElement.scrollTop);
      const thresholdIndex = divElement.scrollHeight - threshold;
      if (scrollCurrentIndex >= thresholdIndex) {
        callback();
      }
    },
    [threshold]
  );

  return (callback: Function) => ({
    ref,
    onScroll: onScroll(callback),
  });
};
